import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';
import { SongUpload, EditImage } from 'client/shared/components';
import { addStore } from 'client/shared/react-util';
import { FieldFactory } from 'client/shared/components';
import { toast } from 'react-toastify';

import Waveform from './waveform'
import FormList from './song-form-list';
@observer
class SongUploadRow extends React.Component {
	render () {
		const { song, artist, songsStore } = this.props;

		if (_.isEmpty(song.downloadFile)) {

			return (
				<div className="margin-bottom-1 primary-font" style={{color: 'black'}}>
					<SongUpload
						fullWidth
						artist={ artist }
						songsStore={ songsStore }
					/>
				</div>
			);
		}

		return (<div><p style={{ color: '#000' }}>Song Uploaded</p></div>);
	}
}

@inject('songsStore', 'formStore', 'userStore', 'artistStore', 'albumsStore')
@observer
class AddSidebar extends React.Component {
	constructor (props) {
		super(props);
		this.state = {
			isAdjusting: false,
			wavesurferRegions: null,
		}
	}
	componentDidMount () {
		
	}
	render () {
		const { songsStore, formStore, artist } = this.props;
		const song = songsStore.songToEdit;
		// const {regionsPlugin} = this.state;

		if (songsStore.isLoading || _.isEmpty(song)) {

			return null;
		}

		const FieldWithStore = addStore(FieldFactory, {
			formStore,
			store: songsStore,
			onChange: () => this.saveSong(song)
		});

		return (
			<div className={`add-song-slideOut ${songsStore.songModalOpen ? `opened ${this.state.isAdjusting ? 'adjust-preview' : ''}` : ''}`}>

				{_.isEmpty(songsStore.songToEdit.streamFile) &&
					<Fragment>
						<div className="section-title artist heading padding-bottom-1">Add New Track</div>
						<SongUploadRow song={ song } artist={ artist } songsStore={ songsStore } />		
						{/* <div className="section-title artist mini padding-bottom-1">Adding: </div> */}
					</Fragment>
				}
				{!_.isEmpty(songsStore.songToEdit.streamFile) &&
					<Fragment>
	2				{!this.state.isAdjusting && (
							<button className="button neo" onClick={() => {this.setState({isAdjusting: true})}}>Adjust Song Preview</button>
						)}
					</Fragment>
				}

				{
					//Adjust song preview UI
					this.state.isAdjusting && (
					<Fragment>
						<button className="button neo" onClick={this.updatePreviewSelection}>Done</button>
						<Waveform id="waveform" url={songsStore.songToEdit.downLoadPath} getRegions={(reg)=>this.setState({wavesurferRegions: reg})}/>
					</Fragment>
				)}

				<div id="songInfoEdit" className="row" style={{display: _.isEmpty(songsStore.songToEdit.streamFile) ? 'none' : 'block'}}>
					<div className="large-12">
						<div className="margin-bottom-2">
							{/* <input className="upload-profile-field" placeholder="Track Title"></input> */}
							<FieldWithStore
								item={ song }
								fieldClass="upload-profile-field"
								fieldKey="song.title"
							/>
						</div>
						<div className="margin-bottom-2">
							{/* <input className="upload-profile-field" placeholder="Songwriter(s)"></input> */}
							<FieldWithStore
								item={ song }
								fieldClass="upload-profile-field"
								fieldKey="song.songWriters"
							/>
						</div>
						<div className="margin-bottom-2">
							{/* <input className="upload-profile-field" placeholder="Additional Artists"></input> */}
							<FieldWithStore
								item={ song }
								fieldClass="upload-profile-field"
								fieldKey="song.additionalArtists"
							/>
						</div>
						<div className="margin-bottom-2">
							{/* <input className="upload-profile-field" placeholder="ISRC"></input> */}
							<FieldWithStore
								item={ song }
								fieldClass="upload-profile-field"
								fieldKey="song.ISRC"
							/>
						</div>
						<div className="margin-bottom-2">
							{/* <input className="upload-profile-field" placeholder="Release Date"></input> */}
							<FieldWithStore
								item={ song }
								fieldClass="upload-profile-field"
								fieldKey="song.releaseDate"
							/>
						</div>
						<div className="margin-bottom-2">
							{/* <input className="upload-profile-field" placeholder="Publisher"></input> */}
							<FieldWithStore
								item={ song }
								fieldClass="upload-profile-field"
								fieldKey="song.publisher"
							/>
						</div>
					</div>
				</div>
				<div className="fixed-container">
					<div className="margin-bottom-2">
						<div className="row">
							<button className="button form okay" disabled={songsStore.isUpLoading} onClick={ this.onCancelClick }>
								Close
							</button>
						</div>
					</div>
				</div>
			</div>
		)
	}

	@autobind 
	updatePreviewSelection () {
		this.setState({isAdjusting: false});
	}
	@autobind
	async saveSong (songToSave) {
		const { userStore, artistStore, } = this.props;
		const user = userStore.getLoggedInUser();
		const artist = artistStore.loggedInArtist;
		await songToSave.save(artist, { silent: true });
		toast.success('Saved!');
		
	}

	@autobind
	onCancelClick () {
		this.setState({isAdjusting: false});
		this.props.songsStore.songToEdit = null;
	}
}

export default AddSidebar;
